import { render, staticRenderFns } from "./CoozzyPhoneAltIcon.vue?vue&type=template&id=3b50e216&scoped=true"
import script from "./CoozzyPhoneAltIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyPhoneAltIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyPhoneAltIcon.vue?vue&type=style&index=0&id=3b50e216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b50e216",
  null
  
)

export default component.exports